import Vue from 'vue';
import Router from 'vue-router';
// 页面
import Home from '@/pages/Home.vue';
import Order from '@/pages/Order.vue';
import OrderBatch from '@/pages/OrderBatch.vue';
import Mine from '@/pages/Mine';
import TempDownload from '@/pages/TempDownload';
import OrderRead from '@/pages/OrderRead';
import Trolley from '@/pages/Trolley';
import Settlement from '@/pages/Settlement';
import OnlinePay from '@/pages/OnlinePay';
import ContactWay from '@/pages/ContactWay';
import Register from '@/pages/Register';
import Retrieve from '@/pages/Retrieve';
import CustomLogin from '@/pages/CustomLogin';
import Agreement from '@/pages/Agreement';
import bj from '@/pages/bj';
Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/home',
			name: 'home',
			component: Home,
		},
		{
			path: '/order',
			name: 'order',
			component: Order,
		},
		{
			path: '/orderBatch',
			name: 'orderBatch',
			component: OrderBatch,
		},
		{
			path: '/mine',
			name: 'mine',
			component: Mine,
			children: [
				{
					path: 'orderManege',
					name: 'orderManege',
					component: () => import('@/pages/mine/OrderManege'),
				},
				{
					path: 'manegeCenter',
					name: 'manegeCenter',
					component: () => import('@/pages/mine/ManegeCenter'),
				},
				
				{
					path: 'orderDetail',
					name: 'orderDetail',
					component: () => import('@/pages/mine/OrderDetail'),
				},
				{
					path: 'financeDetail',
					name: 'financeDetail',
					component: () => import('@/pages/mine/FinanceDetail'),
				},
				{
					path: 'personalInfo',
					name: 'personalInfo',
					component: () => import('@/pages/mine/PersonalInfo'),
				},
				{
					path: 'modifyPassword',
					name: 'modifyPassword',
					component: () => import('@/pages/mine/ModifyPassword'),
				},
				{
					path: 'paymentAccount',
					name: 'paymentAccount',
					component: () => import('@/pages/mine/PaymentAccount'),
				},
				{
					path: 'strategy',
					name: 'strategy',
					component: () => import('@/pages/mine/strategy'),
				},
			]
		},
		{
			path: '/tempDownload',
			name: 'tempDownload',
			component: TempDownload,
		},
		{
			path: '/orderRead',
			name: 'orderRead',
			component: OrderRead,
		},
		{
			path: '/agreement',
			name: 'agreement',
			component: Agreement,
		},
		{
			path: '/trolley',
			name: 'trolley',
			component: Trolley,
		},
		{
			path: '/settlement',
			name: 'settlement',
			component: Settlement,
		},
		{
			path: '/onlinePay',
			name: 'onlinePay',
			component: OnlinePay,
		},
		{
			path: '/contactWay',
			name: 'contactWay',
			component: ContactWay,
		},
		{
			path: '/register',
			name: 'register',
			component: Register,
		},
		{
			path: '/Retrieve',
			name: 'Retrieve',
			component: Retrieve,
		},
		{
			path: '/customLogin/:userid/:f',
			name: 'customLogin',
			component: CustomLogin,
		},
		{
			path: '/bj/:userid/:password/:f',
			name: 'bj',
			component: bj,
		},
		/*默认跳转路由*/
		{
			path: '*',
			redirect: '/home',
		}
		/* {
			path: '/about',
			name: 'about',
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import('./views/About.vue')
		} */
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js